const tipoDocumentos = [
    { value: '1', text: 'Cédula' },
/*     { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' }, */
];

const origenFondo = [
    { value: '1', text: 'SALARIO' },
    { value: '2', text: 'HERENCIA' },
    { value: '3', text: 'AHORRO' },
    { value: '4', text: 'EMPRESA' },
    { value: '5', text: 'OTROS' },
];

const monedas = [
    { value: '1', text: 'Córdobas' },
    { value: '2', text: 'Dólares' },
];

const estadoCivil = [
    { value: '1', text: 'Casado' },
    { value: '2', text: 'Soltero' },
    { value: '3', text: 'Divorciado' },
    { value: '4', text: 'Viudo' },
];

const parentescos = [
    { value: '10', text: 'Sobrino (a)' },
    { value: '13', text: 'Esposo' },
    { value: '14', text: 'Esposa' },
    { value: '16', text: 'Albacea' },
    { value: '19', text: 'Nieto (a)' },
    { value: '20', text: 'Novio (a)' },
    { value: '21', text: 'Hijastra' },
    { value: '24', text: 'Pareja' },
    { value: '25', text: 'Ex-Esposa' },
    { value: '27', text: 'Prima (o)' },
    { value: '28', text: 'Mama De Crianza' },
    { value: '3', text: 'Padre' },
    { value: '30', text: 'Bisabuela' },
    { value: '31', text: 'Madrina' },
    { value: '35', text: 'Nuera' },
    { value: '37', text: 'Exconyuge' },
    { value: '39', text: 'Padrino' },
    { value: '4', text: 'Madre' },
    { value: '41', text: 'Madrasta' },
    { value: '42', text: 'Padrasto' },
    { value: '43', text: 'Hijastro' },
    { value: '5', text: 'Cuñado (a)' },
    { value: '6', text: 'Suegro (a)' },
    { value: '7', text: 'Tio (a)' },
    { value: '8', text: 'Abuelo (a)' },
    { value: '9', text: 'Hermano (a)' },
    { value: 'E', text: 'Conyuge' },
    { value: 'H', text: 'Hijo (a)' },
];

export {tipoDocumentos,origenFondo,monedas,estadoCivil,parentescos};